import { z } from 'zod';
export const DEFAULT_PAGE_SIZE = 50;
export const MAX_PAGE_SIZE = 200;
/**
 * Query params for every list endpoint. Values arrive as strings from the URL,
 * so they are coerced here rather than in each controller.
 */
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    pageSize: z.coerce.number().int().positive().max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
    sortBy: z.enum(['id', 'createdAt']).optional(),
    sortDir: z.enum(['asc', 'desc']).default('desc'),
    search: z.string().trim().max(200).optional(),
});
/** Each list declares the scalar fields it supports before constructing Prisma orderBy. */
export const paginationQueryFor = (sortFields) => paginationQuerySchema.extend({ sortBy: z.enum(sortFields).optional() });
export const paginationMetaSchema = z.object({
    page: z.number().int().positive(),
    pageSize: z.number().int().positive(),
    total: z.number().int().nonnegative(),
    totalPages: z.number().int().nonnegative(),
});
/** Envelope for every paginated response. */
export const paginated = (item) => z.object({ data: z.array(item), meta: paginationMetaSchema });
export const buildPaginationMeta = (page, pageSize, total) => ({
    page,
    pageSize,
    total,
    totalPages: pageSize > 0 ? Math.ceil(total / pageSize) : 0,
});
//# sourceMappingURL=pagination.js.map